import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22.736 3.297a1.275 1.275 0 0 0-1.852-1.318l-18.952 9.95a1.272 1.272 0 0 0 .179 2.333L8 16.281 19 6l-8.902 11 8.596 2.947a1.276 1.276 0 0 0 1.673-1.014zM8.832 17.623v3.27a1.274 1.274 0 0 0 2.12.952l2.838-2.522z" }, null, -1)
  ])))
}
export default { render: render }